import { createRef, useLayoutEffect, useRef, useState } from 'react';

// from https://codesandbox.io/embed/text-overflow-bomo3
const checkOverflow = (el: HTMLDivElement | null) => {
  if (el === null) return false;
  return el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;
};

const usePlayerNameOverflow = (size: number) => {
  const team1PlayerNamesRef = useRef(
    Array(size)
      .fill(null)
      .map(_ => createRef<HTMLDivElement>())
  );
  const team2PlayerNamesRef = useRef(
    Array(size)
      .fill(null)
      .map(_ => createRef<HTMLDivElement>())
  );
  const [playersNamesOverflow, setPlayersNamesOverflow] = useState<[boolean[], boolean[]]>([
    [],
    []
  ]);

  useLayoutEffect(() => {
    if (
      team1PlayerNamesRef.current.every(ref => ref.current) &&
      team2PlayerNamesRef.current.every(ref => ref.current)
    )
      setPlayersNamesOverflow([
        team1PlayerNamesRef.current.map(el => checkOverflow(el.current)),
        team2PlayerNamesRef.current.map(el => checkOverflow(el.current))
      ]);
  }, [team1PlayerNamesRef, team2PlayerNamesRef]);

  return { team1PlayerNamesRef, team2PlayerNamesRef, playersNamesOverflow };
};

export { usePlayerNameOverflow };
